import login from './login';
import route from './route';
import common from './common';
import layout from './layout';
import stuManagement from './student_management';
import validate from './validate';
import message from './message';
import insInfo from './institution_info';
import insInfoSearch from './institution_info_search';
import mps from './mps';
import company from './company';
import tagsView from './tagsView';
import popupNotice from './popup_notice';

export default {
  index: {
    countryDistributionPieTitle: '學生申請意向國家分布',
    nowStudentCount: '{year}學生數',
    nowReadingCount: '{year}{text}',
    allStudentCount: '全部學生數',
    allReadingCount: '全部{text}',
    enrolledSuccessProportion: '成功率',
    studentTotalSum: '學生數（申請數）',
    enrolledSuccess: '成功入讀數',
    enrollment: '成功入讀數',
    applicationCountBarTitle: '申請學生數/{text}',
    applyCount: '申請數',
    goProScore: 'GoPro積分',
    successfulEnrolment: '入學成功數',
    studentCount: '學生數',
    enrolment: '入學數',
    applyStatus: '申請狀態',
    successfulContract: '入學學生數',
    studentOverview: '學生總覽',
    studentQuery: '學生查詢',
    studentQueryList: '學生查詢列表',
    applicationList: '申請列表',
    addStudent: '新增學生',
    pending: "未申請",
    stepNewAppCount: '新申請',
    submitted: '已提交',
    stepFailureCount: '未錄取',
    admittedOffer: '已錄取',
    paid: '已繳費',
    enrolled: '已入學',
    stateUpdate: '狀態更新',
    studentOffer: '學生申請',
    consultant: '顧問',
    studentPage: '學生專頁',
    returnStudentPage: '返回學生專頁',
    newApplication: '新增申請',
    gmtCreate: '創建日期',
    gmtModified: '更新日期',
    application: '申請',
    stepDepositPaidCount: '付定(費)',
    stepOfferSelectionCount: '簽證函',
    stepVisaGrantedCount: '簽證',
    stepEnrolledCount: '入學',
    stepPayPremiumCount: '付傭',
    nationality: '國籍/地區',
    nationalityPassport: '護照國籍/地區',
    passport: '護照',
    passportFrom: '護照國籍/地區',
    birthday: '生日',
    startDate: '開始日期',
    endDate: '結束日期',
    level: '級別',
    course: '課程',
    accommodation: '住宿',
    airportPickup: '接機',
    need: '需要',
    noNeed: '不需要',
    schoolType: '級別',
    school: '學校',
    courseApply: '課程申請',
    applyDetail: '申請詳細',
    applyContentForm: '申請內容表單',
    personalProfile: '個人資料',
    educationalBackground: '教育背景',
    educationBackground: '學歷背景',
    personalBackground: '个人背景',
    referrer: '推薦人 {num}',
    workExperience: '工作經驗',
    professionalQualification: '專業資格',
    applyAttachment: '申請附件',
    addAttachment: '新增附件',
    packWord: '打包成WORD',
    packDownloadAllFile: '打包並下載全部文件',
    applicant: '申請人',
    applicantData: '申請人資料',
    applyId: '申請ID',
    studyCountry: '升學國家/地區',
    studyCountryRegion: '升學國家/地區',
    institutionName: '院校名稱',
    institution: '院校',
    attachment: '附件',
    applyNo: '申請編號',
    statusUpdateDate: '狀態更新日',
    processingDays: '處理天數',
    applyStatusAttachment: '申請狀態附件',
    stepNotes: '步驟備註',
    examType: '考試類型',
    want: '想',
    notWant: '不想',
    ieltsType: 'IELTS 類型',
    examTotal: '總分',
    examListen: '聽',
    examRead: '讀',
    examWrite: '寫',
    examSpeak: '說',
    testCenterNumber: '測試中心號碼',
    examinationDate: '考試日期',
    examinationNumber: '考生號碼',
    examinationCheckAccount: '查詢賬號',
    isReexamination: '會否重考',
    englishExamRecord: '英語考試成績',
    allAttachment: '所有附件',
    uploadDate: '上傳日期',
    fileName: '文件名',
    attachmentTips: '(提交後不能重新上傳/刪除)',
    under18GuardianContact: '18歲以下的監護人聯絡方式',
    contact: '聯絡',
    fatherName: '父親姓名',
    motherName: '母親姓名',
    mobileOrTel: '手機/電話號碼',
    agentContact: '代理聯絡',
    agentMobileOrTel1: '手機/電話 1',
    agentMobileOrTel2: '手機/電話 2',
    agentMobileOrTel3: '手機/電話 3',
    agentEmail1: '電郵 1',
    agentEmail2: '電郵 2',
    agentEmail3: '電郵 3',
    furtherInformation: '背景資料',
    studyCountryLearning: '升學國家/地區學習',
    religion: '宗教信仰',
    isVisaRefused: '曾被拒簽國家/地區',
    isDisability: '殘疾或特殊需求',
    isEnglishMotherLanguage: '英語是你的第一語言',
    isStudyInEnglish: '修讀過英語為授課語言的高中或以上',
    enrolledSchool: '入讀院校{index}',
    uploadFile: '上傳文件',
    typeOfInstitution: '院校類別',
    address: '地址',
    major: '主修',
    studyStartDate: '在校開始時間',
    studyEndDate: '在校結束時間',
    studyInEnglish: '英語教學及考試',
    scoreOrTotal: '分數/總分',
    isCompleted: '完成學習',
    isShouldCompleted: '將會完成',
    studyAndExamInEnglish: '以英語為教學和考試語言',
    studyInEnglishNotExam: '以英語為教學語言但不包括考試',
    secondaryCourses: '中學課程',
    universityOrAboveCourses: '大學以上課程',
    qualificationName: '資格名稱',
    qualificationGroup: '認證機構',
    qualificationRegion: '認證國家/地區',
    qualificationGrade: '評分級別（如適用）',
    qualificationStartDate: '課程開始日期',
    qualificationGetDate: '獲得資格日期',
    qualificationGetStatus: '獲得資格狀態',
    inProgress: '進行中',
    acquired: '已獲得',
    workExperienceTips: '最小號碼為最近工作',
    companyName: '單位名稱',
    position: '職位',
    workMode: '全職/業餘',
    fullTime:'全職',
    partTime: '業餘',
    workStartDate: '在職開始日期',
    workEndDate: '在職結束日期',
    isOnDuty: '目前是否在職',
    jobDescription: '職責描述',
    companyAddress: '單位地址',
    institutionOrCompany: '院校/公司',
    contactAddress: '聯繫地址-(機構/個人)',
    postcode: '郵政編碼',
    name: '姓名',
    openTimeStart: '開學開始日期',
    openTimeEnd: '開學結束日期',
    statusBeginTime: '狀態開始日期',
    statusEndTime: '狀態結束日期',
    statusTimeRange: '狀態日期',
    statusDays: '狀態天數',
    submitStartTime: '提交開始日期',
    submitEndTime: '提交結束日期',
    createStartTime: '創建開始日期',
    createEndTime: '創建結束日期',
    openingTime: '開學日期',
    updateTime: '更新日期',
    submitTime: '提交日期',
    submitter: '提交人',
    days: '天數',
    applicationCountry: '申請國家/地區',
    total: '總數',
    commission: '傭金',
    dataCategory: '數據類別',
    distribution: '分佈情況',
    yearCommission: '年度傭金',
    receivedCommission: '已收傭金',
    unrealizedCommission: '未實現傭金',
    commissionRemark1: '傭金-以學生入學年份計算的預計傭金',
    commissionRemark2: '入學數-以學生入學年份計算年份',
    commissionRemark3: '申請數-以申請創建日計算年份',
    commissionRemark4: '學生數-以創建學生日計算年份',
    overview: '總覽',
    all: '所有',
    settleable: '可結算',
    unsettled: '未結算',
    settling: '結算中',
    received: '已結算/已收款',
    applicationDistribution: '申請分布',
    countryDistribution: '國家分布',
    institutionsDistributionQSRanking: '院校QS排名分布',
    top9: '申請學校TOP9',
    subjectDistribution: '專業分布',
    offerItemCommission: '留學申請',
    serviceFeeCommission: '留學服務費',
    insuranceCommission: '留學保險',
    accommodationCommission: '留學住宿',
    differentialSubmission: '差異提交',
    submitSettlement: '提交結算',
    totalCommission: '总傭金',
    currency: '貨幣',
    tuition: '學費',
    commissionRatio: '佣金比例',
    splitRate: '分成比例',
    paidAmount: '已收金額',
    theReceivable: '本次應收',
    auditOpinion: '審核意見',
    proposeDifference: '提出差異',
    insuranceAmount: '保險金額',
    receivableAmount: '應收金額',
    apartmentName: '學生公寓',
    checkInTime: '入住時間',
    checkInDays: '入住天數',
    payableCommission: '應結傭金',
    currencyType: '貨種',
    type: '類型',
    checkStatement: '核對賬單',
    eSignature: '電子簽名',
    downloadStatement: '備份對賬單',
    previewStatement: '預覽對賬單',
    rolledBack: '對賬單已被回退，點擊查看原因！',
    chineseAccoountTips: '如提供的銀行賬戶是中文賬戶信息，默認為統一用人民幣結算',
    englishAccoountTips: '如提供的銀行賬戶是英文賬戶信息，默認為用外幣結算',
    statementTips1: '外幣結算，需代理提供境外外幣賬戶(香港滙豐優先)，人民幣計算，匯款需通過跨境換匯支付',
    statementTips2: '於結算月中旬導單，合作方收到佣金單後建議3天內(最遲當月20日前)回簽確認',
    statementTips3: '收到合作方回簽確認後，月底至次月中完成匯款',
    statementTips4: '由於跨境匯款限制流程複雜，合作方需在7天內回復是否到賬，超出7天後提出未到賬將不予受理',
    statementTips5: '請確保銀行信息(包括支行)準確，如因賬戶錯誤導致退款所產生手續費由貴公司承擔',
    statementTips6: '匯款參考統一港幣對照匯款當日香港中國銀行早上10點現鈔買入價換匯人民幣結算',
    statementTips7: '院校每次結算時會產生每筆5-8%不等的中間銀行操作手續費，GEA對代理結算(含預付款)時將統一每筆扣除5元本幣種的金額',
    unsettledSubmitTips1: '我們已經開始對您提交的所有賬單進行審核，我們將儘快與您取得聯繫，請注意查收郵件。',
    unsettledSubmitTips2_1: '如有任何問題，請',
    unsettledSubmitTips2_2: '聯繫',
    unsettledSubmitTips2_3: '負責的',
    unsettledSubmitTips2_4: '區域經理',
    unsettledSubmitTips3: '您有負賬單未確認勾選！',
    submitAndESign: '提交並簽名',
    addSubmit: '添加提交',
    bankAccount: '銀行賬戶',
    bankAccountSelect: '請選擇銀行賬戶',
    settleMethod: '結算方式',
    differentCurrency: '不同貨幣結算',
    unifiedCurrency: '統一貨幣結算',
    settleCurrency: '結算幣種',
    originCurrency: '原幣種',
    transactionDate: '交易日期',
    limitFileSize: '上傳文件大小不能超過20M',
    uploadDragTips: '將文件拖到此處，或',
    uploadDragTips2: '點擊上傳',
    uploadESigned: '電子簽署文件上傳',
    uploadedStatement: '已上傳的對賬單',
    uploadStatementTips: '请上傳對賬單',
    receivedTips: '僅顯示最近半年的數據',
    uploadSuccess: '上傳成功！',
    exportNoDataTips: '當前搜索條件無數據可導出！',
    studentUnit: '人',
    noDataSettlingTips: '暫無結算中數據，請先提交結算！',
    hasSettlingCommissionTips: '你有結算中的佣金，需要等待上一次結算完成後才能繼續提交新的結算。上一次提交時間：{time}',
    differentialSubmissionQuestionTips: '如果您對佣金有疑問，可以點擊此按鈕進行反饋，我們會重新為您審核。',
    noSearchResults: "未搜索到相關數據！",
    totalProportion: "占比總數",
    submitSettlementTips: '您填寫完信息還未點擊按鈕提交結算，確定離開嗎？',
    bmsMaskTips: '您的佣金結算已由 BD 在 BMS 系統中處理。如需改為 GEAR 結算，請聯絡您的 BD：',
    signedSucc: '入學登記完成',
    totleStudent: "總學生數",
    welcomeBack: '歡迎回來',
    unsettledDesc: "您可以在此步驟提交結算， 如有疑問請差異提交",
    settlingDesc: "您提交的結算的賬單可在此頁面查看並上傳對賬單",
    receivedDesc: "已完成結算匯款",
    settlementProcessStatus: "結算流程狀態",
    studentEmailTips: "此學生的郵件已存在，如同時提交同一個學生的申請，僅有一名代理獲得佣金。",
    noSignature: '還未進行簽名確認',
    eSignatureTips1: '請提前準備好相關',
    eSignatureTips1_1: '電子簽名',
    eSignatureTips1_2: '和',
    eSignatureTips1_3: '公司電子印章',
    eSignatureTips1_4: '進行上傳。',
    companySealUpload: '公司印章上傳',
    eSignatureUpload: '電子簽名上傳',
    uploadESignature: '上傳電子簽名',
    uploadCompanySeal: '上傳公司印章',
    settlementConfirmation: '確認結算',
    eSignatureTips2: "您還未完成電子簽名並",
    eSignatureTips2_1: "確認結算",
    eSignatureTips2_2: "，確定離開嗎？",
    fileSizeTips: "（建議：文件大小最好控制在2M以內。）",
    comparisonRecord: "對比記錄",
    commissionSettledTips: '每月{start}號至{end}號為結算佣金日期，請在該時間段內結算您的佣金',
    ifApplicable: '如有',
    eSignatureTips3_1: "沒有電子簽名？",
    eSignatureTips3_2: '點擊進行手繪生成',
    handwrittenSignature: '手繪簽名',
    clearSignature: '清除簽名',
    confirmandBackup: '確認',
    eSignatureTips4_1: "請使用",
    eSignatureTips4_2: '參考示例字體大小',
    eSignatureTips4_3: '進行簽名，如簽名字體過小或者不清晰可能會要求重簽，這樣可能會影響結算進度。',
    eSignatureTips5_1: '請確保簽名圖片',
    eSignatureTips5_2: '筆跡清晰可辯背景透明',
    eSignatureTips5_3: '，如使用公司印章，請確保印章清晰。',
    eSignatureTips6_1: '請預覽檢查合成電子簽署後的對賬單，沒有問題則',
    eSignatureTips6_2: '點擊確認結算',
    eSignatureTips7: '請先簽名！',
    pleaseEnterRemark: '請輸入備註',
    currentStatisticsTips:'*目前統計{year}年的最新數據',
  },
  login,
  route,
  common,
  message,
  ...layout,
  stuManagement,
  validate,
  insInfo,
  insInfoSearch,
  mps,
  company,
  tagsView,
  popupNotice,
};
